import { inputAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/react";

const { defineMultiStyleConfig, definePartsStyle } = createMultiStyleConfigHelpers(parts.keys);

const outlineStyle = definePartsStyle({
  field: defineStyle({
    border: "1px solid",
    borderColor: "text.secondary",
    color: "text.input",
    _hover: {
      borderColor: "line.darkGray",
    },
    _active: {
      borderColor: "brand.primary",
    },
    _focus: {
      borderColor: "brand.active",
      boxShadow: "0px 0px 1px #36C19E",
    },
  }),
});

const fillStyle = definePartsStyle({
  field: {
    border: "none",
    color: "text.input",
    bg: "#585858",
    _hover: {
      border: "1px solid",
      borderColor: "line.darkGray",
    },
    _focusVisible: {
      border: "1px solid",
      borderColor: "brand.active",
      boxShadow: "0px 0px 1px #36C19E",
    },
  },
});

const sm = definePartsStyle({
  field: {
    borderRadius: "4px",
    fontSize: "14px",
    h: "34px",
  },
  element: {
    h: "34px",
  },
});

const md = definePartsStyle({
  field: {
    borderRadius: "8px",
    fontSize: "16px",
    h: "40px",
  },
  element: {
    h: "40px",
  },
});

const unsetSize = definePartsStyle({
  field: {
    h: "auto",
    borderRadius: "4px",
  },
});

export const InputTheme = defineMultiStyleConfig({
  variants: {
    outline: outlineStyle,
    fill: fillStyle,
  },
  sizes: {
    sm,
    md,
    unset: unsetSize,
  },
});
